import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Params, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RedirectGuard {
  public matrixParams?: Params;
  public constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    @Inject(DOCUMENT) private _document: Document,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // const hash = this._document.location.hash;
    const url = this._document.location.href;
    if (url.includes('map-explorer/data')) {
      return this._navigateWithMatrixParams();
    }
    return true;
  }
  private async _navigateWithMatrixParams(): Promise<boolean> {
    this._activatedRoute.queryParams.subscribe((queryParams) => {
      this.matrixParams = queryParams;
    });
    if (this.matrixParams && Object.keys(this.matrixParams).length > 0) {
      await this._router.navigate(['/visualization/map-explorer/data', this.matrixParams]);
      return Promise.resolve(false);
    } else {
      return Promise.resolve(true);
    }
  }
}
